import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import notification from 'services/notificationService';

import {
  IUpdateOnlineBookingEnabledRequest,
  IUpdateOnlineBookingEnabledResponse,
  TUpdateOnlineBookingEnabled,
} from './interfaces';
import { UPDATE_ONLINE_BOOKING_ENABLED } from './schema';

export const useOnlineBookingEnabled = (
  t: TTranslator<TLocalesKeys>
): TUpdateOnlineBookingEnabled => {
  const [updateOnlineBookingEnabled] = useMutation<
    IUpdateOnlineBookingEnabledResponse,
    IUpdateOnlineBookingEnabledRequest
  >(UPDATE_ONLINE_BOOKING_ENABLED, {
    onCompleted: () => {
      notification.info({
        t,
        title: t('host.updated'),
        dismiss: 5,
      });
    },
    update: (cache, { data }) => {
      if (!data) return;
      cache.modify({
        id: cache.identify({
          id: data.updateHost.id,
          __typename: 'HostOverview',
        }),
        fields: {
          online_booking_enabled: () => data.updateHost.online_booking_enabled,
        },
      });
    },
  });

  return ({ id, online_booking_enabled }) =>
    updateOnlineBookingEnabled({
      variables: {
        id,
        input: {
          online_booking_enabled,
        },
      },
    });
};
